import {
  LIMIT_TYPES,
  PRODUCT_TYPES,
  TIER_TYPES,
} from "@shared/constants/paidFeaturesHierarchy";

import type { AppConfigType } from "~/types/appConfig";
import type { UserType } from "~/types/user";

export { getMachineThumbnail } from "@shared/utils/getMachineThumbnail";

export const isAssetCreationAllowed = (
  appConfig: AppConfigType,
  user: UserType,
  currentCount: number,
) => {
  const installedProduct = user?.oem?.installedProducts?.find(
    (product) => product.type === PRODUCT_TYPES.ASSET_HUB,
  );

  if (installedProduct?.tier === TIER_TYPES.ENTERPRISE) return true;

  const allowedDocuments =
    appConfig?.plans
      ?.find(({ type }) => type === PRODUCT_TYPES.ASSET_HUB)
      ?.tiers.find(
        ({ type }) =>
          type ===
          user?.oem?.installedProducts?.find(
            ({ type }) => type === PRODUCT_TYPES.ASSET_HUB,
          )?.tier,
      )
      ?.limits.find(({ type }) => type === LIMIT_TYPES.ASSET)?.value || 0;

  if (currentCount >= allowedDocuments) return false;

  return true;
};
